module.exports = __webpack_public_path__ + "media/country_flags/mk-8f89ed46.png";